/* Home v2 — puntos del carrusel de la gama.
   Guardado para que no se enganche dos veces si la sección se duplica. */
(function () {
  function init() {
    var carousels = document.querySelectorAll('.hm2-app .carousel');
    Array.prototype.forEach.call(carousels, function (car) {
      if (car.__hm2) { return; }
      car.__hm2 = true;
      var dots = car.parentElement.querySelector('.dots');
      if (!dots) { return; }
      var dotBtns = Array.prototype.slice.call(dots.querySelectorAll('.dot'));
      var cards = Array.prototype.slice.call(car.querySelectorAll('.pcard'));
      function setActive(i) {
        dotBtns.forEach(function (d, idx) { d.classList.toggle('on', idx === i); });
      }
      var raf;
      car.addEventListener('scroll', function () {
        if (raf) { return; }
        raf = requestAnimationFrame(function () {
          raf = null;
          var center = car.scrollLeft + car.clientWidth / 2;
          var best = 0, bestD = Infinity;
          cards.forEach(function (c, idx) {
            var d = Math.abs((c.offsetLeft + c.offsetWidth / 2) - center);
            if (d < bestD) { bestD = d; best = idx; }
          });
          setActive(best);
        });
      });
      dotBtns.forEach(function (d) {
        d.addEventListener('click', function () {
          var c = cards[parseInt(d.getAttribute('data-i'), 10)];
          if (c) { car.scrollTo({ left: c.offsetLeft - (car.clientWidth - c.offsetWidth) / 2, behavior: 'smooth' }); }
        });
      });
    });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
